<template>
  <div>
    <clip-loader v-show="loading" />
    <div>
      <div v-if="patient" class="row row-eq-height">
        <div class="col-md-12 col-lg-6 mb-3">
          <patient-general-info
            :examination="examination"
            :patient="patient"
            :disable-edit="true"
          />
        </div>

        <div class="col-md-12 col-lg-6 mb-3 consult-reply">
          <diagnose-reply
            :product-type="PRODUCTS.WOUND"
            :disable-new-answer="true"
            :edit-save-uri="
              '/api/internal/patients/' + $route.params.id + '/comments'
            "
          />
        </div>
      </div>

      <div class="row row-eq-height">
        <div class="col-md-12 col-lg-6 mb-3">
          <wound-medical-history
            :is-editing="isEditing"
            :examination="examination"
          />
        </div>

        <div class="col-md-12 col-lg-6 mb-3">
          <wound-vascular-history
            :is-editing="isEditing"
            :examination="examination"
          />
        </div>
      </div>

      <div class="row row-eq-height">
        <div class="col-md-12 col-lg-6 mb-3">
          <wound-history :is-editing="isEditing" :examination="examination" />
        </div>

        <div class="col-md-12 col-lg-6 mb-3">
          <patient-case-diagnosis :examination="examination" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DiagnoseReply from "../../../Examinations/AddOns/DiagnoseReply.vue";

import WoundMedicalHistory from "./WoundMedicalHistory.vue";
import WoundVascularHistory from "./WoundVascularHistory.vue";

import PatientGeneralInfo from "../../PatientGeneralInfo.vue";
import PatientCaseDiagnosis from "./PatientCaseDiagnosis.vue";
import WoundHistory from "./WoundHistory.vue";
import { PRODUCTS } from "../../../../helpers/definitions";

export default {
  components: {
    DiagnoseReply,
    WoundMedicalHistory,
    PatientGeneralInfo,
    PatientCaseDiagnosis,
    WoundVascularHistory,
    WoundHistory,
  },
  props: ["patient"],
  data() {
    return {
      loading: true,
      isEditing: false,
      displayHistory: true,
      examination: null,
      PRODUCTS: PRODUCTS,
    };
  },

  mounted: function () {
    if (this.$route.params.id) {
      this.loadData();
    }
  },
  methods: {
    loadData: function () {
      axios
        .get("/api/internal/patients/" + this.$route.params.id + "/wound")
        .then((response) => {
          if (!$.isEmptyObject(response.data)) {
            this.examination = response.data;
          }

          this.loading = false;
        });
    },
    submitChanges: function () {
      let instance = this;
      this.$vueAlert
        .confirm(
          this.trans("patient.patientmodalCreateCaseConfirmation"),
          undefined,
          undefined,
          {
            confirmButtonText: this.trans("general.modalConfirmButton"),
            cancelButtonText: this.trans("general.modalCancelButton"),
          },
        )
        .then(function () {
          instance.loading = true;

          axios
            .post(
              "/api/internal/patients/" + instance.$route.params.id + "/wound",
              instance.examination,
            )
            .then((response) => {
              instance.loading = false;
              instance.isEditing = false;
              instance.examination = response.data;
              instance.$snotify.success(
                this.trans("general.notificationSaved"),
              );
            });
        });
    },
    editWound: function (bool) {
      this.isEditing = bool;
    },
  },
};
</script>
